import React from 'react';
import { Card, CardContent } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import EmptyState from '../../components/ui/empty-state.jsx';
import LoadingSpinner from '../../components/common/LoadingSpinner.jsx';
import { useNotifications } from '../../hooks/useNotifications';
import { Bell } from 'lucide-react';

const NotificationsPage = () => {
  const { notifications, loading, error, fetchNotifications, markAsRead, deleteNotification } = useNotifications();

  if (loading) return <LoadingSpinner />;
  if (error) return (
    <div className="p-6">
      <Card>
        <CardContent className="p-6">
          <p className="text-red-600 text-sm">{String(error)}</p>
          <Button className="mt-3" onClick={() => fetchNotifications()}>Retry</Button>
        </CardContent>
      </Card>
    </div>
  );

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h2 className="text-xl font-semibold">Notifications</h2>
        <div className="flex items-center gap-2">
          <Button variant="outline" size="sm" onClick={() => fetchNotifications()}>Refresh</Button>
        </div>
      </div>

      {(!notifications || notifications.length === 0) ? (
        <EmptyState 
          icon={Bell}
          title="No notifications"
          description="You're all caught up."
          action
          actionLabel="Refresh"
          onAction={() => fetchNotifications()}
        />
      ) : (
        <div className="space-y-2">
          {notifications.map((n) => (
            <Card key={n.id}>
              <CardContent className="p-4 flex items-center justify-between">
                <div>
                  <p className="text-sm font-semibold text-gray-900">{n.title}</p>
                  <p className="text-xs text-gray-600">{n.message}</p>
                  <p className="text-xs text-gray-500 mt-1">{new Date(n.createdAt).toLocaleString()} • {n.type}</p>
                </div>
                <div className="flex items-center gap-2">
                  {!n.isRead && (
                    <Button size="sm" variant="outline" onClick={() => markAsRead(n.id)}>Mark as read</Button>
                  )}
                  <Button size="sm" variant="outline" onClick={() => deleteNotification(n.id)}>Delete</Button>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
};

export default NotificationsPage;


